import Icon from '../components/Icon.vue'

Icon.register({
  'chart-line': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 384H64V80C64 71.2 56.8 64 48 64H16C7.2 64 0 71.2 0 80V416C0 433.7 14.3 448 32 448H496C504.8 448 512 440.8 512 432V400C512 391.2 504.8 384 496 384zM464 96H345.9C324.6 96 313.9 121.9 329 137L361.4 169.4 288 242.8 214.6 169.4C202.1 156.9 181.9 156.9 169.4 169.4L100.7 238.1C94.4 244.3 94.4 254.4 100.7 260.7L123.3 283.3C129.6 289.6 139.7 289.6 145.9 283.3L192 237.3 265.4 310.6C277.9 323.1 298.1 323.1 310.6 310.6L406.6 214.6 439 247C454.1 262.1 480 251.4 480 230.1V112C480 103.2 472.8 96 464 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chart-line.js
// module id = /H0l
// module chunks = 144